<template>
    <Breadcrumbs main="Form Widgets" title="Select2" />
    <div class="container-fluid">
        <div class="select2-drpdwn">
            <div class="row">
                <selectView />
                <outlineColor />
                <fullColored />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const selectView = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/select2/selectView.vue"))
const outlineColor = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/select2/outlineColor.vue"))
const fullColored = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/select2/fullColored.vue"))
</script>